/** @jsx jsx */
import { jsx } from '@emotion/react';
import { colors } from '../../src/theme';

export default () => {
  return (
    <svg
      css={{ width: '18px', height: '18px', stroke: colors.font, '&:hover': { stroke: colors.primary } }}
      width="14"
      height="14"
      stroke="none"
      viewBox="0 0 22 22"
      fill="none"
    >
      <path
        d="M19 8H10C8.89543 8 8 8.89543 8 10V19C8 20.1046 8.89543 21 10 21H19C20.1046 21 21 20.1046 21 19V10C21 8.89543 20.1046 8 19 8Z"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 14H3C2.46957 14 1.96086 13.7893 1.58579 13.4142C1.21071 13.0391 1 12.5304 1 12V3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1H12C12.5304 1 13.0391 1.21071 13.4142 1.58579C13.7893 1.96086 14 2.46957 14 3V4"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
